// extracted by mini-css-extract-plugin
export default {"wrapper":"adult-page_wrapper__oalet","title":"adult-page_title__vkNK7"};